module.exports = __webpack_public_path__ + "img/drill_assess_abnormal.c829d32e.png";